import React from 'react'
import { useGetFaqListMutation, useGetFaqTypesMutation, useGetUserGuideByIdMutation, useGetUserGuidesForClientMutation } from '../redux/faqs/faqsApiSlice';
import { toast } from 'react-toastify';
import { getErrorMessage } from '../utils/commonUtils';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../redux/store';
import { setFaqList, setFaqTypes, setUserGuides } from '../redux/faqs/faqsSlice';

const useFaqs = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [getFaqTypes, { isLoading: getFaqTypesLoading }] = useGetFaqTypesMutation();
    const [getFaqList, { isLoading: getFaqListLoading }] = useGetFaqListMutation();
    const [getUserGuidesForClient, { isLoading: getUserGuidesLoading }] = useGetUserGuidesForClientMutation();
    const [getUserGuideById, { isLoading: getUserGuideByIdLoading }] = useGetUserGuideByIdMutation();

    const getFaqTypesAPI = async () => {
        try {
            const response = await getFaqTypes({}).unwrap();
            dispatch(setFaqTypes(response.result));
            return response.result;
        } catch (err: any) {
            const message = getErrorMessage(err);
            throw new Error(message);
        }
    };

    const getFaqListAPI = async (data: Record<string, any>) => {
        try {
            const response = await getFaqList(data).unwrap();
            dispatch(setFaqList(response.result));
            return response.result;
        } catch (err: any) {
            const message = getErrorMessage(err);
            throw new Error(message);
        }
    };

    const getUserGuidesAPI = async () => {
        try {
            const response = await getUserGuidesForClient({ isActive: true }).unwrap();
            dispatch(setUserGuides(response.result));
            return response.result;
        } catch (err: any) {
            const message = getErrorMessage(err);
            throw new Error(message);
        }
    };

    const getUserGuideByIdAPI = async (data: Record<string, any>) => {
        try {
            const response = await getUserGuideById(data).unwrap();
            return response.result;
        } catch (err: any) {
            const message = getErrorMessage(err);
            throw new Error(message);
        }
    }

    return {
        getFaqTypesAPI,
        getFaqTypesLoading,
        getFaqListAPI,
        getFaqListLoading,
        getUserGuidesAPI,
        getUserGuidesLoading,
        getUserGuideByIdAPI,
        getUserGuideByIdLoading,
    };
}

export default useFaqs;
